(function(){

var PRODS = {
  kreatin: {
    name:'Kreatin Gummies',
    img:'https://cdn.shopify.com/s/files/1/0757/3100/9803/files/KreatinKorsbar_41932cc1-167c-49c5-a51a-e504757a615e.png?v=1787769861',
    url:'/products/kreatin-gummies-korsbar',
    price:'299 kr', was:null, soldout:false,
    reason:'Kreatin ökar muskelstyrka och explosiv kraft – kliniskt bevisad och den mest beforskade supplementen som finns.'
  },
  ashwagandha: {
    name:'Ashwagandha Gummies',
    img:'https://cdn.shopify.com/s/files/1/0757/3100/9803/files/Ashwagandha_460d9f52-03c2-473f-823f-afd257d96a86.png',
    url:'/products/ashwagandha-gummies',
    price:'299 kr', was:null, soldout:false,
    reason:'Ashwagandha rotextrakt sänker cortisol och ger stabil energi utan kraschar – kliniskt bevisad effekt.'
  },
  shilajit_g: {
    name:'Shilajit Gummies',
    img:'https://cdn.shopify.com/s/files/1/0757/3100/9803/files/Shilajit_ColorBackground.png',
    url:'/products/shilajit-gummies',
    price:'399 kr', was:null, soldout:false,
    reason:'Fulvinsyra och 80+ mineraler – ett kraftfullt adaptogen för vitalitet och ork vid oregelbunden vardag.'
  },
  magnesium: {
    name:'Magnesium + L-teanin & GABA',
    img:'https://cdn.shopify.com/s/files/1/0757/3100/9803/files/Mangesium_ColorBackground.jpg',
    url:'/products/magnesium-l-teanin-gaba',
    price:'349 kr', was:null, soldout:true,
    reason:'Trion som hjälper dig slappna av och sova djupare – utan att du känner dig dimmig nästa morgon.'
  },
  lionsmane: {
    name:"Lion's Mane Gummies",
    img:'https://cdn.shopify.com/s/files/1/0757/3100/9803/files/Lion_smanewithbackground.png',
    url:'/products/lions-mane-gummies',
    price:'299 kr', was:null, soldout:false,
    reason:"Stimulerar NGF – nervcellstillväxtfaktorn – för bättre fokus, minne och kognitiv uthållighet."
  },
  seamoss: {
    name:'Sea Moss Gummies',
    img:'https://cdn.shopify.com/s/files/1/0757/3100/9803/files/SeaMossColorBackground.png',
    url:'/products/sea-moss-gummies',
    price:'249 kr', was:null, soldout:false,
    reason:'92 av kroppens 102 mineraler i en och samma gummy. Fundamentalt för immunförsvar och energinivåer.'
  },
  shilajit_r: {
    name:'Shilajit Resin',
    img:'https://cdn.shopify.com/s/files/1/0757/3100/9803/files/Shilajit_fpk.png',
    url:'/products/shilajit-resin',
    price:'249 kr', was:null, soldout:false,
    reason:'Koncentrerat Himalaya-shilajit – maximal biotillgänglighet för vitalitet, testosteron och mitokondriefunktion.'
  },
  fiber: {
    name:'Fiber Gummies',
    img:'https://cdn.shopify.com/s/files/1/0757/3100/9803/files/Produktbild_fiber_6c216788-b362-4941-881c-79a0095a3bd2.png',
    url:'/products/fiber-gummies',
    price:'279 kr', was:null, soldout:false,
    reason:'Stödjer tarmhälsa, mättnadskänsla och stabilt blodsocker – utan stimulanter eller tillsatser.'
  },
  dvitamin: {
    name:'D-vitamin Gummies',
    img:'https://cdn.shopify.com/s/files/1/0757/3100/9803/files/Produktbild_dvitamin_08235968-c8ce-4a00-afb0-37fe4fbfcdf5.png',
    url:'/products/d-vitamin-gummies',
    price:'199 kr', was:null, soldout:true,
    reason:'Solsken på burk. D-vitamin är kritiskt för energi, immunförsvar och humör under mörka månader.'
  },
  zinkjarn: {
    name:'Zink & Järn Gummies',
    img:'https://cdn.shopify.com/s/files/1/0757/3100/9803/files/Produktbild_jarn_zink_876d5792-be96-4ed4-8c94-13c58c90d529.png',
    url:'/products/jarn-zink-gummies',
    price:'199 kr', was:null, soldout:true,
    reason:'Täpper igen de vanligaste näringsluckorna hos veganer och aktiva – zink och järn i ett.'
  }
};

var QS = [
  { id:'goal', q:'Vad är ditt främsta mål just nu?', hint:'Välj det som stämmer bäst.', multi:false,
    opts:[
      {i:'💪',l:'Bygga styrka & muskler',  d:'Träning och prestation',       v:'muscle'  },
      {i:'🧠',l:'Fokus & mental skärpa',   d:'Koncentration & produktivitet',v:'focus'   },
      {i:'😴',l:'Bättre sömn',             d:'Återhämtning & ro',            v:'sleep'   },
      {i:'⚡',l:'Mer energi',              d:'Orka mer varje dag',           v:'energy'  },
      {i:'🌿',l:'Allmänt välmående',       d:'Stärka hälsan generellt',      v:'wellness'},
      {i:'🔥',l:'Gå ner i vikt',           d:'Form & ämnesomsättning',       v:'weight'  }
    ]
  },
  { id:'energy_pattern', q:'Hur är din energi i vardagen?', hint:'', multi:false,
    opts:[
      {i:'⚡',l:'Hög och stabil',      d:'Orkar bra hela dagen',     v:'stable'     },
      {i:'📉',l:'Varierar under dagen',d:'Toppar och dalar',          v:'variable'   },
      {i:'🌅',l:'Trög på morgonen',    d:'Tar lång tid att komma igång', v:'morning'},
      {i:'🌙',l:'Slut på kvällen',     d:'Svårt att varva ner & återhämta', v:'evening'}
    ]
  },
  { id:'lifestyle', q:'Hur aktiv är du i vardagen?', hint:'', multi:false,
    opts:[
      {i:'🏋️',l:'Väldigt aktiv',           d:'4+ pass i veckan',        v:'active'    },
      {i:'🚶',l:'Måttligt aktiv',            d:'1–3 pass i veckan',       v:'moderate'  },
      {i:'💻',l:'Mestadels stillasittande',  d:'Skrivbordsarbete',        v:'sedentary' },
      {i:'🌙',l:'Oregelbunden',              d:'Skiftarbete eller nätter',v:'nightshift'}
    ]
  },
  { id:'diet', q:'Hur ser din kost ut?', hint:'', multi:false,
    opts:[
      {i:'🥩',l:'Allätare',                d:'Äter allt',                v:'omni'  },
      {i:'🥗',l:'Mestadels växtbaserat',   d:'Lite kött/fisk',           v:'plant' },
      {i:'🌱',l:'Veganskt / vegetariskt',  d:'Inga animaliska produkter',v:'vegan' },
      {i:'🤷',l:'Varierat',                d:'Inget speciellt mönster',  v:'varied'}
    ]
  },
  { id:'age', q:'Vilken åldersgrupp tillhör du?', hint:'Hjälper oss anpassa rekommendationen.', multi:false,
    opts:[
      {i:'🧑',l:'Under 25',d:'',v:'u25' },
      {i:'🧑‍💼',l:'25–35', d:'',v:'2535'},
      {i:'👨',l:'36–50',   d:'',v:'3650'},
      {i:'👴',l:'Över 50', d:'',v:'o50' }
    ]
  },
  { id:'experience', q:'Erfarenhet av kosttillskott?', hint:'', multi:false,
    opts:[
      {i:'✅',l:'Ja, regelbundet',d:'Vet vad som funkar', v:'yes' },
      {i:'🔄',l:'Ja, lite grann', d:'Lite erfarenhet',    v:'some'},
      {i:'❌',l:'Nej, aldrig',    d:'Helt ny för mig',    v:'no'  }
    ]
  }
];

function buildRecs(ans) {
  var s={}, goal=(ans.goal||[])[0], diet=(ans.diet||[])[0], age=(ans.age||[])[0], ls=(ans.lifestyle||[])[0];
  function add(k,p){s[k]=(s[k]||0)+p;}
  var gm={muscle:'kreatin',focus:'lionsmane',sleep:'magnesium',energy:'ashwagandha',wellness:'seamoss',weight:'fiber'};
  if(gm[goal]) add(gm[goal],10);
  var ep=(ans.energy_pattern||[])[0];
  if(ep==='variable') {add('ashwagandha',7);add('magnesium',4);}
  if(ep==='morning')  {add('shilajit_g',7);add('dvitamin',5);}
  if(ep==='evening')  {add('magnesium',8);add('ashwagandha',4);}
  if(ep==='stable')   {add('seamoss',4); add('lionsmane',3);}
  if(ls==='active')    {add('kreatin',4);add('shilajit_g',3);}
  if(ls==='nightshift'){add('shilajit_g',6);add('magnesium',4);}
  if(ls==='sedentary') {add('dvitamin',3);add('ashwagandha',3);}
  if(diet==='vegan'||diet==='plant'){add('zinkjarn',7);add('dvitamin',4);}
  if(age==='o50') {add('shilajit_r',8);add('dvitamin',5);add('seamoss',4);}
  if(age==='3650'){add('shilajit_r',3);}
  var keys=Object.keys(s).sort(function(a,b){return s[b]-s[a];});
  if(!keys.length) keys=['seamoss','ashwagandha'];
  if(keys.length===1) keys.push(goal==='muscle'?'ashwagandha':'kreatin');
  return keys.slice(0,3).map(function(k){return PRODS[k];}).filter(Boolean);
}

var _st={};
function st(id){if(!_st[id])_st[id]={step:0,ans:{}};return _st[id];}

function renderQ(id){
  var s=st(id), q=QS[s.step], saved=s.ans[q.id]||[], total=QS.length;
  document.getElementById('hqFill-'+id).style.width=Math.round(s.step/total*100)+'%';
  document.getElementById('hqLbl-'+id).textContent='Fråga '+(s.step+1)+' av '+total;
  document.getElementById('hqBack-'+id).disabled=s.step===0;
  /* Nästa-knapp borttagen — auto-advance sköter navigationenen */
  var hintHtml=q.hint+(q.multi?' <span style="opacity:.55">(välj ett alternativ)</span>':'');
  var optsHtml=q.opts.map(function(o){
    var sel=saved.indexOf(o.v)>-1?' sel':'';
    return '<button class="hq-opt'+sel+'" onclick="window._hqPk(\''+id+'\',\''+q.id+'\',\''+o.v+'\','+(!!q.multi)+','+(q.max||1)+',this)">'+
      '<span class="hq-oi">'+o.i+'</span>'+
      '<span class="hq-ol">'+o.l+'</span>'+
      (o.d?'<span class="hq-od">'+o.d+'</span>':'')+
      '</button>';
  }).join('');
  document.getElementById('hqArea-'+id).innerHTML=
    '<div class="hq-qcard">'+
      '<p class="hq-qtitle">'+q.q+'</p>'+
      (q.hint?'<p class="hq-qhint">'+hintHtml+'</p>':'')+
      '<div class="hq-opts">'+optsHtml+'</div>'+
    '</div>';
}

window._hqPk=function(id,qid,val,multi,max,el){
  var s=st(id);if(!s.ans[qid])s.ans[qid]=[];var arr=s.ans[qid];
  if(multi){
    var i=arr.indexOf(val);
    if(i>-1){arr.splice(i,1);el.classList.remove('sel');}
    else if(arr.length<max){arr.push(val);el.classList.add('sel');}
  } else {
    s.ans[qid]=[val];
    document.querySelectorAll('#hqArea-'+id+' .hq-opt').forEach(function(b){b.classList.remove('sel');});
    el.classList.add('sel');
    /* Auto-advance efter 260ms för single-choice */
    setTimeout(function(){ hqNext(id); }, 260);
  }
};

window.hqStart=function(id){
  document.getElementById('hqIntro-'+id).style.display='none';
  document.getElementById('hqQuiz-'+id).style.display='block';
  renderQ(id);
};
window.hqNext=function(id){
  var s=st(id);
  if(s.step<QS.length-1){
    s.step++;renderQ(id);
    var qEl=document.getElementById('hqQuiz-'+id);
    var r=qEl.getBoundingClientRect();
    /* Scrolla bara om quizet inte redan syns i viewport */
    if(r.top < 0 || r.top > window.innerHeight * 0.3){
      qEl.scrollIntoView({behavior:'smooth',block:'nearest'});
    }
  }
  else{
    document.getElementById('hqQuiz-'+id).style.display='none';
    _showResult(id,buildRecs(s.ans),s.ans);
  }
};
window.hqBack=function(id){var s=st(id);if(s.step>0){s.step--;renderQ(id);}};


function _showResult(id,recs,ans){
  var goal=(ans.goal||[])[0]||'wellness';
  var gl={muscle:'styrka & muskler',focus:'fokus & skärpa',sleep:'bättre sömn',energy:'mer energi',wellness:'välmående',weight:'viktnedgång'};
  document.getElementById('hqRH-'+id).textContent='För dig som vill ha '+(gl[goal]||'din hälsa')+':';

  var esc=function(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});};
  var html=recs.map(function(p,i){
    var top=i===0;
    var sold=p.soldout;
    return '<div class="hq-card'+(top?' top':'')+'">'+
      (top?'<span class="hq-top-tag">Bäst match</span>':'')+
      '<img class="hq-card-img" src="'+esc(p.img)+'" alt="'+esc(p.name)+'" loading="lazy" width="460" height="460">'+
      '<div class="hq-card-body">'+
        (sold?'<span class="hq-sold-badge">Slut</span>':'')+
        '<p class="hq-card-name">'+esc(p.name)+'</p>'+
        '<p class="hq-card-reason">'+esc(p.reason)+'</p>'+
        '<p class="hq-card-price">'+esc(p.price)+(p.was?'<span class="hq-was">'+esc(p.was)+'</span>':'')+' </p>'+
        (sold
          ? '<span class="hq-card-btn is-sold">Slut</span>'
          : '<a href="'+esc(p.url)+'" class="hq-card-btn">Köp nu</a>')+
      '</div>'+
    '</div>';
  }).join('');

  document.getElementById('hqCards-'+id).innerHTML=html;
  document.getElementById('hqResult-'+id).style.display='block';
  document.getElementById('hqResult-'+id).scrollIntoView({behavior:'smooth',block:'start'});
}

window.hqRestart=function(id){
  _st[id]={step:0,ans:{}};
  ['hqResult-','hqQuiz-'].forEach(function(p){var el=document.getElementById(p+id);if(el)el.style.display='none';});
  document.getElementById('hqIntro-'+id).style.display='block';
  document.getElementById('hq-'+id).scrollIntoView({behavior:'smooth',block:'nearest'});
};

})();
